/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Autocomplete,
  Chip,
  Divider,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { Vocabulary } from "../../../../Utils/Vocabulary";
import { Delete } from "@mui/icons-material";
import { toast } from "react-toastify";
import { TaxRateModel } from "../../../../Utils/Models";
import { useEffect, useState } from "react";
import { getData } from "../../../../Services/getData";
import { urlEnum } from "../../../../Utils/UrlEnum";
import { postData } from "../../../../Services/postData";

type ProductsListProps = {
  products: any;
  showPrice: boolean;
  onChangeProducts: (products: any) => void;
  vatList?: Array<TaxRateModel>;
};

export default function ProductsList(props: ProductsListProps) {
  const { products, showPrice, onChangeProducts, vatList } = props;
  const phoneStyle = useMediaQuery("(max-width: 800px)");
  const productMaxLength = phoneStyle ? 7 : 30;
  const [measureUnits, setMeasureUnits] = useState<any[]>([]);
  const [measureUnit, setMeasureUnit] = useState<any>();

  useEffect(() => {
    getData(`${urlEnum.measureUnits}`).then((response) => {
      setMeasureUnits(response.data);
    });
  }, []);

  function calculateTotalPrice(
    pricePerQty: number,
    quantity: number,
    VATvalue: any,
    markup: number
  ): number {
    const vatRate = VATvalue?.value || 0;
    const basePrice = +pricePerQty * +quantity;
    const markupAmount = (basePrice * markup) / 100;
    return +(basePrice + markupAmount + (basePrice * vatRate) / 100).toFixed(2);
  }

  function onChangePrice(event: any, index: number, isTotalPrice: boolean) {
    const newProducts: any = [...products];
    if (isTotalPrice) {
      newProducts[index].totalPrice = event.target.value;
    } else {
      newProducts[index].pricePerQuantity = event.target.value;
      const { quantity, VATvalue, markup = 0 } = newProducts[index];
      newProducts[index].totalPrice = calculateTotalPrice(
        event.target.value,
        quantity,
        VATvalue,
        markup
      );
    }
    onChangeProducts(newProducts);
  }

  function onChangeQuantity(event: any, index: number) {
    const newProducts: any = [...products];
    newProducts[index].quantity = event.target.value;
    const { pricePerQuantity, VATvalue, markup = 0 } = newProducts[index];
    newProducts[index].totalPrice = calculateTotalPrice(
      pricePerQuantity,
      event.target.value,
      VATvalue,
      markup
    );
    onChangeProducts(newProducts);
  }

  function onChangeVAT(selected: any, index: number) {
    const newProducts: any = [...products];
    newProducts[index].VATvalue = selected;
    const { pricePerQuantity, quantity, markup = 0 } = newProducts[index];
    newProducts[index].totalPrice = calculateTotalPrice(
      pricePerQuantity,
      quantity,
      selected,
      markup
    );
    onChangeProducts(newProducts);
  }

  function deleteProductFromStockTransfer(index: number) {
    const newProducts = [...products];
    newProducts.splice(index, 1);
    onChangeProducts(newProducts);
  }

  return (
    <div style={{ marginTop: 20 }}>
      {products.map((product: any, index: number) => (
        <>
          <div
            key={product._id}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignContent: "left",
              alignItems: "center",
              margin: "10px 0px",
            }}
          >
            <Chip
              label={
                <>
                  {product.product.code} -{" "}
                  {product.product.name?.length > productMaxLength
                    ? `${product.product.name?.substring(0, productMaxLength)}...`
                    : product.product.name}
                </>
              }
              style={{
                borderRadius: 4,
                fontSize: 15,
                backgroundColor: `${product.product._id ? "#40CC8C" : "#ffde00"}`,
                height: "auto",
                padding: 7,
                flex: 1,
                marginRight: 15,
              }}
            />
            <Autocomplete
              size="small"
              id="measureUnit"
              options={measureUnits || []}
              value={product.measureUnit}
              getOptionLabel={(option: any) => option?.name || ""}
              isOptionEqualToValue={(option: any, value: any) =>
                option.name === value.name
              }
              onChange={(event: any, value: any) => {
                const newProducts: any = [...products];
                newProducts[index].measureUnit = value;
                onChangeProducts(newProducts);
              }}
              renderInput={(params: any) => (
                <TextField
                  {...params}
                  fullWidth
                  label={Vocabulary.measureUnits}
                  variant="outlined"
                  error={!product.measureUnit || !product.measureUnit.name}
                  helperText={
                    !product.measureUnit || !product.measureUnit.name
                      ? Vocabulary.requiredField
                      : ""
                  }
                  onChange={(event) => {
                    if (event.target.value) {
                      setMeasureUnit({
                        name: event.target.value,
                      });
                    }
                  }}
                  onKeyDown={async (event) => {
                    if (event.key === "Enter" && measureUnit?.name !== "") {
                      const isNew = !measureUnits.some(
                        (value) => value.name === measureUnit.name
                      );
                      if (isNew) {
                        await postData(`${urlEnum.measureUnits}`, measureUnit);
                        setMeasureUnits((prev) => [...prev, measureUnit]);
                      }
                    }
                  }}
                />
              )}
              style={{ width: "25%", margin: "9px 10px 0 5px" }}
            />
            <TextField
              type="number"
              size="small"
              name="quantity"
              label={Vocabulary.quantity}
              variant="standard"
              value={product.quantity}
              onChange={(event: any) => {
                if (parseFloat(event.target.value) > parseFloat(product.maxQuantity)) {
                  toast.error(`${Vocabulary.maxQuantityIs} ${product.maxQuantity}`);
                  return;
                }
                onChangeQuantity(event, index);
              }}
              style={{ marginRight: 10 }}
            />
          </div>
          <div
            style={{ display: "flex", alignItems: "center", marginBottom: 20 }}
          >
            {showPrice && (
              <>
                <TextField
                  type="number"
                  size="small"
                  name="pricePerQuantity"
                  label={Vocabulary.pricePerQuantity}
                  variant="standard"
                  value={product.pricePerQuantity}
                  onChange={(event: any) => {
                    onChangePrice(event, index, false);
                  }}
                  style={{ marginRight: 10 }}
                />
                <Autocomplete
                  size="small"
                  id="type"
                  freeSolo={true}
                  options={vatList || []}
                  disabled={false}
                  value={product.VATvalue}
                  getOptionLabel={(option: any) => option.name}
                  isOptionEqualToValue={(option: any, value: any) =>
                    option === value
                  }
                  style={{ width: "25%", margin: "9px 10px 0 5px" }}
                  onChange={(event: any, newValue: any) => {
                    onChangeVAT(newValue, index);
                  }}
                  renderInput={(params: any) => (
                    <TextField
                      {...params}
                      fullWidth
                      label={Vocabulary.VAT}
                      variant="outlined"
                      validators={["required"]}
                      errorMessages={[Vocabulary.requiredField]}
                    />
                  )}
                />
                <TextField
                  type="number"
                  size="small"
                  name="commercialMarkup"
                  label={Vocabulary.commercialmarkup}
                  variant="standard"
                  value={product.markup || 0}
                  onChange={(event: any) => {
                    const newProducts: any = [...products];
                    const newMarkup = parseFloat(event.target.value) || 0;

                    newProducts[index].markup = newMarkup;

                    const { pricePerQuantity, quantity, VATvalue } = newProducts[index];
                    newProducts[index].totalPrice = calculateTotalPrice(
                      pricePerQuantity,
                      quantity,
                      VATvalue,
                      newMarkup
                    );

                    onChangeProducts(newProducts);
                  }}
                  style={{ marginRight: 10 }}
                />
                <TextField
                  type="number"
                  size="small"
                  name="totalPrice"
                  label={Vocabulary.totalPrice}
                  variant="standard"
                  value={product.totalPrice}
                  onChange={(event: any) => {
                    onChangePrice(event, index, true);
                  }}
                  style={{ marginRight: 10 }}
                />
              </>
            )}
            <Delete
              style={{
                cursor: "pointer",
                color: "red",
              }}
              onClick={() => {
                deleteProductFromStockTransfer(index);
              }}
            />
          </div>
          <Divider />
        </>
      ))}
    </div>
  );
}
